import palette from 'src/designSystem/variables/palette'
import { RISK_MATH } from '@trustero/trustero-api-web/lib/risk/risk_pb'
import { RISK_MATH_BG } from '../Risks/risks.constants'
import { DashboardType, GrcDashboardTab } from './GrcDashboards.types'

export enum RiskLevel {
  NOT_SET = 'Not Set',
  VERY_LOW = 'Very Low',
  LOW = 'Low',
  MODERATE = 'Moderate',
  HIGH = 'High',
  VERY_HIGH = 'Very High',
}

export enum RiskResponseView {
  RESIDUAL = 'Residual',
  INHERENT = 'Inherent',
  BOTH = 'Both',
}

export enum RiskResponseSectionName {
  RISK_MANAGEMENT = 'Risk management',
  RISK_ASSESSMENT = 'Risk assessment',
}

export const CONTROL_CHECK_RESULT_COLORS: Record<string, string> = {
  '0': '#F87682',
  '1': '#45B786',
  '2': '#4C5E6E',
}

export const CONTROL_CHECK_RESULT_SELECTED_COLORS: Record<string, string> = {
  '0': 'red',
  '1': palette.green['900'],
  '2': palette.neutral['900'],
}

export const RISK_MANAGEMENT_COLORS: Record<string, string> = {
  '0': '#F87682',
  '1': '#45B786',
  '2': '#4C5E6E',
}

export const RISK_ASSESSMENT_COLORS: Record<RiskLevel, string> = {
  [RiskLevel.NOT_SET]: RISK_MATH_BG[RISK_MATH.NOT_SET],
  [RiskLevel.VERY_LOW]: RISK_MATH_BG[RISK_MATH.VERY_LOW],
  [RiskLevel.LOW]: RISK_MATH_BG[RISK_MATH.LOW],
  [RiskLevel.MODERATE]: RISK_MATH_BG[RISK_MATH.MODERATE],
  [RiskLevel.HIGH]: RISK_MATH_BG[RISK_MATH.HIGH],
  [RiskLevel.VERY_HIGH]: RISK_MATH_BG[RISK_MATH.VERY_HIGH],
}

export const RISK_ASSESSMENT_TEXT_COLORS: Record<string, string> = {
  [RiskLevel.NOT_SET]: palette.neutral['900'],
  [RiskLevel.VERY_LOW]: palette.neutral['900'],
  [RiskLevel.LOW]: palette.neutral['900'],
  [RiskLevel.MODERATE]: palette.neutral['900'],
  [RiskLevel.HIGH]: palette.neutral['900'],
  [RiskLevel.VERY_HIGH]: palette.neutral.white,
}
export const RISK_ASSESSMENT_COLORS_BOTH: Record<string, string> = {
  'Very High-Inherent': RISK_MATH_BG[RISK_MATH.VERY_HIGH],
  'High-Inherent': RISK_MATH_BG[RISK_MATH.HIGH],
  'Moderate-Inherent': RISK_MATH_BG[RISK_MATH.MODERATE],
  'Low-Inherent': RISK_MATH_BG[RISK_MATH.LOW],
  'Very Low-Inherent': RISK_MATH_BG[RISK_MATH.VERY_LOW],
  'Not Set-Inherent': RISK_MATH_BG[RISK_MATH.NOT_SET],
  'Very High-Residual': RISK_MATH_BG[RISK_MATH.VERY_HIGH],
  'High-Residual': RISK_MATH_BG[RISK_MATH.HIGH],
  'Moderate-Residual': RISK_MATH_BG[RISK_MATH.MODERATE],
  'Low-Residual': RISK_MATH_BG[RISK_MATH.LOW],
  'Very Low-Residual': RISK_MATH_BG[RISK_MATH.VERY_LOW],
  'Not Set-Residual': RISK_MATH_BG[RISK_MATH.NOT_SET],
}

export const CONTROL_CHECK_RESULT_DATA_KEYS = ['2', '0', '1']

export const RISK_MANAGEMENT_DATA_KEYS = ['1', '0', '2']

export const RISK_ASSESSMENT_DATA_KEYS = [
  RiskLevel.VERY_HIGH,
  RiskLevel.HIGH,
  RiskLevel.MODERATE,
  RiskLevel.LOW,
  RiskLevel.VERY_LOW,
  RiskLevel.NOT_SET,
]

export const RISK_LEVEL_TO_RISK_MATH: Record<RiskLevel, RISK_MATH> = {
  [RiskLevel.VERY_HIGH]: RISK_MATH.VERY_HIGH,
  [RiskLevel.HIGH]: RISK_MATH.HIGH,
  [RiskLevel.MODERATE]: RISK_MATH.MODERATE,
  [RiskLevel.LOW]: RISK_MATH.LOW,
  [RiskLevel.VERY_LOW]: RISK_MATH.VERY_LOW,
  [RiskLevel.NOT_SET]: RISK_MATH.NOT_SET,
}

export const GRC_KEY_TO_DASHBOARD_TYPE: Record<string, GrcDashboardTab> = {
  '0': GrcDashboardTab.COMPLIANCE,
  '1': GrcDashboardTab.OE_OVERVIEW,
  '2': GrcDashboardTab.OE_DETAIL,
  '3': GrcDashboardTab.RISK_RESPONSE,
}

export const GRC_DASHBOARD_TYPE_TO_KEY: Record<GrcDashboardTab, string> = {
  [GrcDashboardTab.COMPLIANCE]: '0',
  [GrcDashboardTab.OE_OVERVIEW]: '1',
  [GrcDashboardTab.OE_DETAIL]: '2',
  [GrcDashboardTab.RISK_RESPONSE]: '3',
}

export const GRC_DASHBOARD_TYPE_IS_AUDIT_SPECIFIC: Record<
  DashboardType,
  boolean
> = {
  [DashboardType.OE_OVERVIEW]: true,
  [DashboardType.OE_DETAIL]: true,
  [DashboardType.RISK_RESPONSE]: true,
}
